import { useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { IGlobalPartnerDetails } from '../../../../../models/globalPartnerDetails'

export const useMultiselectCruds = (data: IGlobalPartnerDetails[]) => {
  const totalPartners = useMemo(() => {
    return data.filter((it) => it.PartnerId !== null)
  }, [data])

  const uniqManagers = Array.from(new Set(totalPartners.map((el) => el.Manager))).filter(Boolean)
  const uniqPBMs = Array.from(new Set(totalPartners.map((el) => el.PBM))).filter(Boolean)

  const partnerIdCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(
        totalPartners.map((el) => {
          return {
            id: el.PartnerId,
            value: el.PartnerName,
          }
        })
      ),
      keyField: 'id',
    })
  }, [totalPartners])

  const managersCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(
        uniqManagers.map((manager) => {
          return {
            value: manager,
          }
        })
      ),
      keyField: 'value',
    })
  }, [uniqManagers])

  const pbmsCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(
        uniqPBMs.map((pbm) => {
          return {
            value: pbm,
          }
        })
      ),
      keyField: 'value',
    })
  }, [uniqPBMs])

  return { partnerIdCrud, managersCrud, pbmsCrud }
}
